import { useRef, useState, useCallback } from 'react';
export function useSwipeToDismiss(_ref) {
  let {
    onDismiss,
    direction = 'bottom',
    dismissThreshold = 0.25,
    velocityThreshold = 0.05,
    transformElementRef,
    enabled = true
  } = _ref;
  const [isDragging, setDragging] = useState(false);
  const [transform3DValues, setTransform3DValues] = useState(['0', '0', '0']);
  const pointerStart = useRef(0);
  const dragStartTime = useRef(null);
  const elementRef = useRef(null);
  const isVertical = direction === 'top' || direction === 'bottom';
  const directionMultiplier = direction === 'bottom' || direction === 'right' ? 1 : -1;
  const getElementHeight = useCallback(() => {
    const element = transformElementRef.current || elementRef.current;
    if (!element) {
      return 0;
    }
    return isVertical ? element.getBoundingClientRect().height : element.getBoundingClientRect().width;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVertical]);
  const onPress = useCallback(event => {
    if (!enabled) {
      return;
    }
    const element = event.currentTarget;
    elementRef.current = element;
    setDragging(true);
    dragStartTime.current = new Date();
    pointerStart.current = isVertical ? event.pageY : event.pageX;

    // Обеспечиваем правильный захват указателя
    element.setPointerCapture(event.pointerId);
  }, [enabled, isVertical]);
  const onDrag = useCallback(event => {
    if (!enabled || !isDragging || !elementRef.current) {
      return;
    }
    const currentPosition = isVertical ? event.pageY : event.pageX;
    const delta = (pointerStart.current - currentPosition) * directionMultiplier;

    // Разрешаем перетаскивание только в направлении закрытия
    if (delta < 0) {
      if (isVertical) {
        setTransform3DValues(['0', "".concat(-delta * directionMultiplier, "px"), '0']);
      } else {
        setTransform3DValues(["".concat(-delta * directionMultiplier, "px"), '0', '0']);
      }
    }
  }, [enabled, isDragging, isVertical, directionMultiplier]);
  const onRelease = useCallback(event => {
    if (!enabled || !isDragging || !elementRef.current || !dragStartTime.current) {
      return;
    }
    const endTime = new Date();
    const currentPosition = isVertical ? event.pageY : event.pageX;
    const timeTaken = endTime.getTime() - dragStartTime.current.getTime();
    const distMoved = pointerStart.current - currentPosition;
    const velocity = Math.abs(distMoved) / timeTaken;
    const elementSize = getElementHeight();
    const dismissDistance = elementSize * dismissThreshold;
    const lastTransform = transform3DValues;
    const moveDirection = distMoved > 0 ? 1 : -1;
    // Сбрасываем состояние
    setTransform3DValues(['0', '0', '0']);
    setDragging(false);

    // Определяем, нужно ли закрыть
    if ((velocity > velocityThreshold || Math.abs(distMoved) >= dismissDistance) && moveDirection === -1) {
      onDismiss === null || onDismiss === void 0 || onDismiss(lastTransform);
    }
    dragStartTime.current = null;
  }, [enabled, isDragging, transform3DValues, isVertical, getElementHeight, dismissThreshold, velocityThreshold, onDismiss]);
  return {
    transform3DValues,
    isDragging,
    onPointerDown: onPress,
    onPointerMove: onDrag,
    onPointerUp: onRelease,
    onPointerCancel: onRelease
  };
}